import { render } from "./QRReader.vue?vue&type=template&id=09432002&ts=true"
import script from "./QRReader.vue?vue&type=script&lang=ts"
export * from "./QRReader.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\vue_workspace\\gokou-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__